import defaultReducers from '@src/models/defaultReducers'
import { ActionGoalSummariesQuery } from '../graphql/actionGoalSummaries.generated'
import { ActionGoalsStoreState } from './actionGoals.types'

export const reducers = {
  ...defaultReducers,
  updateActionGoalSummaries: (
    state: ActionGoalsStoreState,
    { payload }: { payload: ActionGoalSummariesQuery['actionGoalSummaries'] },
  ) => {
    return {
      ...state,
      summariesByWeek: {
        ...state.summariesByWeek,
        [payload.startDate]: payload.actionGoalSummaries,
      },
    }
  },
}

export default reducers
